import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";

export function useCertificatesACLRoles() {
  const { can } = useAcl();

  function canManageCertificates() {
    return can(ACLRoles.CAN_WRITE_FEATURE);
  }

  function canViewCertificates() {
    return can(ACLRoles.CAN_READ_FEATURE);
  }

  return {
    canManageCertificates,
    canViewCertificates,
  };
}
